<template>
  <div id="app">
    <!-- isUserLoggedIn &&  -->
    <!-- 全局Toast提示 -->
    <CustomToast
      v-model:show="showToast"
      :message="toastMessage"
      :type="toastType"
    />

    <div class="bottom_tabs" v-if="shouldShowBottomTabs">
      <div
        v-for="(item, index) in bottomTabs"
        :key="item.name"
        class="bottom_tab"
        @click="switchTab(index)"
      >
        <img
          :src="activeTab === index ? item.selectUrl : item.normalUrl"
          alt=""
        />
        <p :class="activeTab === index ? 'active' : ''">{{ item.name }}</p>
      </div>
    </div>
    <router-view />
  </div>
</template>

<script>
import { env } from "@/utils/env";
import CustomToast from "@/components/CustomToast.vue";
// import { userApi, wechatApi } from '@/api'

export default {
  name: "App",
  components: {
    CustomToast,
  },
  data() {
    return {
      // Toast相关状态
      showToast: false,
      toastMessage: "",
      toastType: "info",
      // 微信浏览器和登录状态检查结果
      isWechatBrowser: false,
      isUserLoggedIn: false,
      isInitialCheckComplete: false,

      bottomTabs: [
        {
          name: "首页",
          selectUrl: require("@/assets/home_select3x.png"),
          normalUrl: require("@/assets/home3x.png"),
          route: "/home",
          defaultRoute: true, // 标记为默认路由
        },
        {
          name: "加入我们",
          selectUrl: require("@/assets/join_select3x.png"),
          normalUrl: require("@/assets/join3x.png"),
          route: "/join",
        },
        {
          name: "优选资源",
          selectUrl: require("@/assets/good_select3x.png"),
          normalUrl: require("@/assets/good3x.png"),
          route: "/good",
        },
        {
          name: "小工具",
          selectUrl: require("@/assets/tool_select3x.png"),
          normalUrl: require("@/assets/tool3x.png"),
          route: "/tool",
        },
        {
          name: "我的",
          selectUrl: require("@/assets/center_select3x.png"),
          normalUrl: require("@/assets/center3x.png"),
          route: "/center",
        },
      ],
      activeTab: 0,
    };
  },
  computed: {
    // 控制底部导航栏是否显示
    shouldShowBottomTabs() {
      // 在这些路由下不显示底部导航栏
      const hideBottomTabsRoutes = [
        "/center/records",
        "/center/addAccount/add",
        "/center/addAccount",
        "/center/withdraw",
        "/center/addAccount/edit",
        "/center/manage",
        "/contactUs",
        "/setup/index",
        "/center/notices/info",
        "/center/notices/index",
        "/login",
        "/guide",
        "/auth_callback",
        "/social_coefficient",
        "/balance_record",
		"/user_agreement",
		"/privacy_agreement",
		"/withdraw/record"
      ];
      return !hideBottomTabsRoutes.includes(this.$route.path);
    },
  },
  watch: {
    // 监听路由变化，更新选中的tab
    "$route.path"(newPath) {
      const tabIndex = this.bottomTabs.findIndex(
        (tab) => tab.route === newPath || (newPath === "/" && tab.defaultRoute)
      );
      if (tabIndex !== -1) {
        this.activeTab = tabIndex;
      }
    },
  },
  methods: {
    // 处理全局toast事件
    handleShowToast(data) {
      this.toastMessage = data.message;
      this.toastType = data.type || "info";
      this.showToast = true;
    },

    switchTab(index) {
      this.activeTab = index;
      // 路由跳转到对应的页面
      this.$router.push(this.bottomTabs[index].route);
    },

    // 检查是否为微信浏览器
    checkWechatBrowser() {
      this.isWechatBrowser = env.isWechatBrowser();
      return this.isWechatBrowser;
    },

    // 检查用户登录状态
    async checkUserLoginStatus() {
      try {
        //todo
        //  localStorage.setItem(
        //    "token",
        //    // "30|HHMGXP06xWEKnvXEdAOacDCKcu0dzp60L1sJIzKwb27c2f1e"
        // "9|HnDzq51wm9k3hVE7kd7JmTdgf4KoyTKNcLQyfbbad64207cf"
        //  );
        // 首先检查本地是否有token
        const token = localStorage.getItem("token");
        if (!token) {
          this.isUserLoggedIn = false;
          return false;
        }

        this.isUserLoggedIn = true;
        return true;
      } catch (error) {
        this.isUserLoggedIn = false;
        // 清除无效的token
        localStorage.removeItem("token");
        return false;
      }
    },

    // 检查微信登录状态
    async checkWechatLoginStatus() {
      if (!this.isWechatBrowser) {
        console.log("非微信浏览器，跳过微信登录检查");
        return false;
      }
      try {
        // await wechatApi.checkWechatLogin()
        console.log("微信用户已登录");
        return true;
      } catch (error) {
        console.log("微信用户未登录:", error.message);
        return false;
      }
    },

    // 初始检查：微信浏览器和登录状态
    async performInitialCheck() {
      // 检查微信浏览器
      this.checkWechatBrowser();

      // 检查用户登录状态
      await this.checkUserLoginStatus();

      // 如果是微信浏览器，检查微信登录状态
      if (this.isWechatBrowser) {
        await this.checkWechatLoginStatus();
      }

      this.isInitialCheckComplete = true;

      // 更新全局状态
      this.$checkStatus.updateStatus({
        isWechatBrowser: this.isWechatBrowser,
        isUserLoggedIn: this.isUserLoggedIn,
        isInitialCheckComplete: this.isInitialCheckComplete,
      });

      // 保存状态到localStorage，供其他组件访问
      const checkStatus = {
        isWechatBrowser: this.isWechatBrowser,
        isUserLoggedIn: this.isUserLoggedIn,
        isInitialCheckComplete: this.isInitialCheckComplete,
        timestamp: Date.now(),
      };
      localStorage.setItem("app_check_status", JSON.stringify(checkStatus));

      // 这里可以触发自定义事件或执行其他业务逻辑
      this.$emit("initial-check-complete", {
        isWechatBrowser: this.isWechatBrowser,
        isUserLoggedIn: this.isUserLoggedIn,
      });
    },
  },
  async mounted() {
    // 初次进入页面时检查微信浏览器和登录状态
    await this.performInitialCheck();

    // 监听全局toast事件
    this.$eventBus.$on("show-toast", this.handleShowToast);

    // 根据当前路由设置选中的tab
    const currentRoute = this.$route.path;
    const tabIndex = this.bottomTabs.findIndex(
      (tab) =>
        tab.route === currentRoute || (currentRoute === "/" && tab.defaultRoute)
    );
    if (tabIndex !== -1) {
      this.activeTab = tabIndex;
    } else {
      // 默认选中的tab为首页
      this.activeTab = 0;
    }
  },
  beforeUnmount() {
    // 移除事件监听器
    this.$eventBus.$off("show-toast", this.handleShowToast);
  },
};
</script>

<style lang="scss" scoped>
#app {
  width: 100%;
  height: 100vh;
  background: #f9fcff;
  position: relative;
  .bottom_tabs {
    width: 100%;
    height: 1.36rem;
    background: #ffffff;
    box-shadow: 0px 0px 0.08rem 0px rgba(0, 0, 0, 0.16);
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding: 0 0.5rem;
    padding-top: 0.2rem;
    .bottom_tab {
      height: 100%;
      width: 1.2rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: start;
      img {
        width: 0.48rem;
        height: 0.48rem;
      }
      p {
        font-size: 0.24rem;
        color: #666;
        margin-top: 0.04rem;
        &.active {
          color: #202020; // 选中的文字颜色，可以根据需要修改
          font-weight: 500;
        }
      }
    }
  }
}
</style>
